const masterchefjoev2 = require("./masterchefjoe_v2");
const masterchefjoev3 = require("./masterchefjoe_v3");

module.exports = {
  UNIV2_ROUTER_ADDRESS: "0x60ae616a2155ee3d9a68541ba4544862310933d4",
  FARMS: {
    masterchefjoev2,
    masterchefjoev3
  },
};
